import { Skeleton } from '@/components/atoms/Skeleton';
import { theme } from '@/styles/theme';

export default function ListagemItensCarrinhoFallback() {
  return (
    <div
      style={{
        paddingTop: theme.spacing[5],
        paddingRight: theme.spacing[4],
        paddingLeft: theme.spacing[4],
        gap: theme.spacing[5],
        paddingBottom: theme.spacing[5],
      }}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: theme.spacing[4],
        }}
      >
        <Skeleton style={{ width: '25vw', height: 32 }} />
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: theme.spacing[5],
          }}
        >
          <Skeleton style={{ height: 160 }} />
          <Skeleton style={{ height: 1 }} />
          <Skeleton style={{ height: 73 }} />
          <Skeleton style={{ height: 1 }} />
          <Skeleton style={{ height: 73 }} />
        </div>
      </div>
    </div>
  );
}
